import React, {FC} from 'react';
import {GUTTER} from "../../../constants";
import {Col, Row} from "antd";
import {ActivityAttributeReport, DashboardProduct} from "../../../types";
import {AttributeValuesDistributionPieChartCard} from "./AttributeValuesDistributionPieChartCard";
import {AttributePerformanceColumnChartCard} from "./AttributePerformanceColumnChartCard";
import { QueryFilter } from '../../../components/DataTable/Filters/types';
import { useQuerySearchParams } from '../../../config/queryClient';

interface Props {
    product?: DashboardProduct
}

export const ActivityAttributeReportRow: FC<Props> = ({product}) => {
    const {data = []} = useQuerySearchParams<ActivityAttributeReport[]>(
        `/reports/activity-attributes/`,
        [QueryFilter.COHORTS, QueryFilter.COURSES],
        {defaultFilters: {meta: product?.primary_attribute_meta?.id || ''}}
    );

    if (data.length < 2) {
        return null;
    }

    return (
        <Row gutter={GUTTER}>
            <Col xl={12} xs={24}>
                <AttributeValuesDistributionPieChartCard attributeMeta={product?.primary_attribute_meta}/>
            </Col>
            <Col xl={12} xs={24}>
                <AttributePerformanceColumnChartCard attributeMeta={product?.primary_attribute_meta}/>
            </Col>
        </Row>
    );
};